import userReducer from './user_slice'
import {configureStore} from '@reduxjs/toolkit'
import UtilSlice from './UtilSlice'
import {TypedUseSelectorHook, useDispatch, useSelector} from 'react-redux'
export const store = configureStore({
    reducer: {
        util: UtilSlice,
        user: userReducer,
    },
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
export const useAppDispatch: () => AppDispatch = useDispatch
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
